/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react'
import { onAnchorTriggerKey } from '../../utils'
import './_top-taskbar.scss'
import { SubNavigationRelatedLinksProps } from './SubNavigationRelatedLinks'
import AccountSettings from '../AccountSettings/AccountSettings'
import { AuthInfo, CurrentUser } from '../typedefs'

export type TopTaskBarProps = {
  authInfo: AuthInfo
  handleClosePopupClick: () => void
  handleLogOut: (() => void) | null
  handleLogIn: (() => void) | null
  onAccountSettingsFirstShow: (() => void) | null
}

export type TopTaskBarItem = {
  label?: string
  menus: SubNavigationRelatedLinksProps[]
  title: string
  text?: { text: string }
  authInfo: AuthInfo
}

export type LanguageDetails = {
  languageCode: string
  language: string
}

export class TopTaskBar extends React.Component<TopTaskBarProps> {
  state = {
    authComponent: null
  }

  componentDidMount() {
    this.setAuthComponent()
  }

  componentDidUpdate(prevProps: TopTaskBarProps) {
    const { authInfo } = this.props
    if (authInfo !== prevProps.authInfo) {
      this.setAuthComponent()
    }
  }

  setAuthComponent() {
    const {
      authInfo,
      handleLogIn,
      handleLogOut,
      onAccountSettingsFirstShow,
      handleClosePopupClick
    } = this.props
    const { currentUser } = authInfo
    let authComponent = null
    if (handleLogIn && handleLogOut) {
      if (authInfo.isAuthenticated === null) {
        // we support login and logout but the state of the current user
        // is still indeterminate.
        authComponent = null
      } else if (currentUser && currentUser.isAuthenticated) {
        // This `if` condition ^^^ relies solely on currentUser being non-null.
        // That's because React sometimes renders twice, the first time with
        // authInfo.isAuthenticated=true, authInfo.currentUser=null. Relying
        // on currentUser only avoid NPEs.
        authComponent = (
          <AccountSettings
            handleLogOut={handleLogOut}
            onFirstShow={onAccountSettingsFirstShow}
            currentUser={authInfo.currentUser as CurrentUser}
            handleClosePopupClick={handleClosePopupClick}
          />
        )
      } else {
        authComponent = (
          <div
            role="link"
            tabIndex={0}
            className="frw-account"
            onClick={handleLogIn}
            onKeyDown={onAnchorTriggerKey(handleLogIn)}
          >
            <span className="frw-account__sign-in">
              <i className="far fa-user-circle" /> Sign In
            </span>
            <span className="frw-account__divider">|</span>
            <span className="frw-account__register">Register</span>
          </div>
        )
      }
    }
    this.setState({ authComponent })
  }

  render() {
    const { authComponent } = this.state
    return (
      <>
        <div className="frw-top-bar">
          <div className="frw-wrapper--1 frw-content">
            <div className="frw-top-bar__left" />
            <div className="frw-top-bar__right">{authComponent}</div>
          </div>
        </div>
      </>
    )
  }
}
export default TopTaskBar
